import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Spin, Row, Col } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import apiRequest from '../hooks/ApiRequest';
import Layouts from '../components/Layouts';

const Communication = () => {
  const [nationalID, setNationalID] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const UserDetail = JSON.parse(localStorage.getItem('user'))
  useEffect(() => {
    fetchRoles()
  }, [])

  const fetchRoles = async () => {
    setLoading(true)
    try {
      let endpoint = ''

      if (UserDetail?.role === '305') {
        endpoint = `/Notification/GetNotificationsByBrokerId/GetByBroker/${UserDetail?.UserId}`
      } else {
        endpoint = `/Notification/GetNotificationsByCustomerId/GetByCustomer/${UserDetail?.UserId}`
      }

      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_EMAIL + endpoint,
      )

      if (response.success) {
        const data = response.data || []
        const formattedData = data.map(item => ({
          id: item.id,
          policy_number: item.notificationType,
          description: item.message,
          client_name:
            UserDetail?.role === '305'
              ? item.customerName
              : item.brokerName,
          date: new Date(item.displayTime).toLocaleString(),
        }))
        setBaseData(formattedData)
      }
    } catch (error) {
      console.error('Error fetching notifications', error)
    } finally {
      setLoading(false)
    }
  }



  const handleSearch = () => {
    fetchRoles()
  }

  const columns = [
    {
      title: 'Category',
      dataIndex: 'policy_number',
      key: 'policy_number',
      width: 150,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 450,
    },
    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',
      width: 250,
    },
    {
      title: 'Time',
      dataIndex: 'date',
      key: 'date',
      width: 250,
    },
  ]

  return (
    <Layouts title="Insurers" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Communication
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8}>
            <div className="item-search">
              <Input.Search
                placeholder="Search ..."
                prefix={<SearchOutlined />}
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={4}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={handleSearch}
                style={{ marginLeft: 10 }}>
                Search
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ display: 'block', marginTop: 20 }}
        />
      ) : (
        <div id="divToPrint">
          <Table columns={columns} dataSource={baseData} rowKey="id" />
        </div>
      )}
    </Layouts>
  )
}

export default Communication;
